// extracted by mini-css-extract-plugin
module.exports = {"Container":"RichTextWithTitle_Container__hkuOY","Title":"RichTextWithTitle_Title__1aNl2"};